export default "__VITE_ASSET__27b4810a__"